import React, { lazy } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { isModuleEnabled } from '../../lib/helpers'

const Calendar = lazy(() => import('../../containers/Calendar'))
const Certificate = lazy(() => import('../../containers/Certificate'))
const Covid = lazy(() => import('../../containers/Covid'))
const EvacuationAssistance = lazy(() => import('../../containers/EvacuationAssistance'))
const Dashboard = lazy(() => import('../../containers/Dashboard'))
const Documents = lazy(() => import('../../containers/Documents'))
const DSAL = lazy(() => import('../../containers/DSAL'))
const FloorPlans = lazy(() => import('../../containers/FloorPlans'))
const FloorWarden = lazy(() => import('../../containers/FloorWarden'))
const Library = lazy(() => import('../../containers/Library'))
const Neighbourhood = lazy(() => import('../../containers/Neighbourhood'))
const Notifications = lazy(() => import('../../containers/Notifications'))
const Procedures = lazy(() => import('../../containers/Procedures'))
const Profile = lazy(() => import('../../containers/Profile'))
const Reports = lazy(() => import('../../containers/Reports'))
const Resources = lazy(() => import('../../containers/Resources'))
const Support = lazy(() => import('../../containers/Support'))

// // Temporary Reports
const ReportPrograms = lazy(() => import('../../components/Admin/Reports/Programs'))
const ReportProgram = lazy(() => import('../../components/Admin/Reports/Programs/ProgramReport'))
const ReportProgramTenant = lazy(() => import('../../components/Admin/Reports/Programs/ProgramTenantReport'))

const ReportTenants = lazy(() => import('../../components/Admin/Reports/Tenants'))
const Acknowledgments = lazy(() => import('../../components/Admin/Reports/Acknowledgement'))
const IamSafe = lazy(() => import('../../components/Admin/Reports/IamSafe'))

// ADMIN VIEWS
const Admin = lazy(() => import('../../containers/Admin'))
const AdminEvacuationAssistance = lazy(() => import('../../containers/Admin/EvacuationAssistance'))
const AdminFloorWarden = lazy(() => import('../../containers/Admin/FloorWarden'))
const ClientDetails = lazy(() => import('../../components/Admin/Clients/Details'))
const BuildingDetails = lazy(() => import('../../components/Admin/Buildings/Details'))
const Propertydetails = lazy(() => import('../../components/Admin/Properties/Details'))
const Tenantdetails = lazy(() => import('../../components/Admin/Tenants/Details'))
const UserDetails = lazy(() => import('../../components/Admin/Users/Details'))
const TrainingPortal = lazy(() => import('../../containers/TrainingPortal'))
const TrainingProgram = lazy(() => import('../../containers/TrainingProgram'))
const DSALAdmin = lazy(() => import('../../containers/Admin/DSAL'))

export default () => {
    const isAdmin = useSelector((state) => state.app.isAdmin)
    const roles = useSelector((state) => state.app.user.roles)
    const modules = useSelector((state) => state.app.building.settings?.modules)

    return (
        <Switch>
            {isModuleEnabled(modules, 'dashboard') && (
                <Route exact path="/">
                    <Dashboard />
                </Route>
            )}

            {isModuleEnabled(modules, 'evacAssistance') && (
                <Route exact path="/assistance">
                    <EvacuationAssistance />
                </Route>
            )}

            {isModuleEnabled(modules, 'calendar') && (
                <Route exact path="/calendar">
                    <Calendar />
                </Route>
            )}
            <Route
                exact
                path="/certificate/:playlistId"
                render={(props) => <Certificate {...props} />}
            />
            <Route
                exact
                path="/certificate/:playlistId/:userData"
                render={(props) => <Certificate {...props} />}
            />
            {isModuleEnabled(modules, 'documents') && (
                <Route exact path="/documents">
                    <Documents />
                </Route>
            )}
            <Route exact path="/dsal">
                <DSAL />
            </Route>

            {isModuleEnabled(modules, 'floorPlans') && (
                <Route exact path="/floorplans">
                    <FloorPlans />
                </Route>
            )}
            {(isModuleEnabled(modules, 'floorWarden') ||
                isModuleEnabled(modules, modules?.ERT)) && (
                    <Route exact path="/floorwarden">
                        <FloorWarden />
                    </Route>
                )}

            {isModuleEnabled(modules, 'map') && (
                <Route exact path="/neighborhood">
                    <Neighbourhood />
                </Route>
            )}

            {isModuleEnabled(modules, 'notifications') && (
                <Route exact path="/notifications">
                    <Notifications />
                </Route>
            )}
            {isModuleEnabled(modules, 'procedures') && (
                <Route exact path="/procedures">
                    <Procedures />
                </Route>
            )}
            {isModuleEnabled(modules, 'reports') && (
                <Route exact path="/reports">
                    <Reports />
                </Route>
            )}

            {isModuleEnabled(modules, 'covid') && (
                <Route exact path="/covid">
                    <Covid />
                </Route>
            )}

            <Route exact path="/trainingportal">
                <TrainingPortal />
            </Route>
            <Route
                exact
                path="/trainingprogram/:pk"
                render={(props) => <TrainingProgram {...props} />}
            />

            <Route exact path="/profile">
                <Profile />
            </Route>

            {isModuleEnabled(modules, 'additionalResources') && (
                <Route exact path="/resources">
                    <Resources />
                </Route>
            )}
            {isModuleEnabled(modules, 'support') && (
                <Route exact path="/support">
                    <Support />
                </Route>
            )}

            {roles.includes('superadmin') && (
                <Route exact path="/library" render={(props) => <Library {...props} />} />
            )}

            {isAdmin &&
                <>
                    <Route exact path="/admin/:view">
                        <Admin />
                    </Route>
                    <Route exact path="/admin/clients/:clientId">
                        <ClientDetails />
                    </Route>
                    <Route exact path="/admin/buildings/:buildingId">
                        <BuildingDetails />
                    </Route>
                    <Route exact path="/admin/properties/:propertyId">
                        <Propertydetails />
                    </Route>
                    <Route exact path="/admin/user/:userId">
                        <UserDetails />
                    </Route>
                    <Route exact path="/admin/tenants/:tenantId">
                        <Tenantdetails />
                    </Route>

                    <Route exact path="/reports/floorwarden">
                        <AdminFloorWarden />
                    </Route>
                    <Route exact path="/reports/assistance">
                        <AdminEvacuationAssistance />
                    </Route>

                    <Route exact path="/reports/programs/:buildingId">
                        <ReportPrograms />
                    </Route>

                    <Route exact path="/reports/program/:buildingId/:id">
                        <ReportProgram />
                    </Route>

                    <Route exact path="/reports/program/:buildingId/:id/:tenantId">
                        <ReportProgramTenant />
                    </Route>

                    <Route exact path="/reports/acknowledgments">
                        <Acknowledgments />
                    </Route>

                    <Route exact path="/reports/tenants">
                        <ReportTenants />
                    </Route>
                    <Route exact path="/reports/iamsafe">
                        <IamSafe />
                    </Route>
                    <Route exact path="/reports/dsal">
                        <DSALAdmin />
                    </Route>
                </>}

            {/* <Redirect to={{ pathname: false && modules?.dashboard ? '/' : '/trainingportal'}}/> */}
        </Switch >
    )
}